<script lang="ts">
    import { onMount } from "svelte";
    import type DataProvider from "../services/data.provider";
    import type ServiceProvider from "../services/service.provider";
    import type { ActionType } from "../interfaces/interfaces";

    export let dataProvider: DataProvider;
    export let serviceProvider: ServiceProvider;

    let actionTypes: ActionType[] = [];
    let errorActionTypes = false;
    let processingActionTypes = false;

    onMount(() => serviceProvider.searchService.loadActionTypes());

    serviceProvider.searchService.actionTypesSubs.subscribe(
        (data) => (actionTypes = data)
    );

    serviceProvider.searchService.errorActionTypesSubs.subscribe(
        (status) => (errorActionTypes = status)
    );

    serviceProvider.searchService.processingActionTypesSubs.subscribe(
        (status) => (processingActionTypes = status)
    );

    const onSubmit = (): void => serviceProvider.searchService.submitSearch();
</script>

<form
    class="bno-hero-banner__form"
    on:submit|preventDefault={onSubmit}
    style="align-items: center;"
    aria-label="Vyhledávání akcí"
>
    <div class="bno-search bno-search--compact">
        <div class="bno-search__inner">
            <div class="bno-form-control">
                <input
                    id="input-search"
                    bind:value={dataProvider.searchString}
                    class="bno-form-control__input bno-form-control__input--standalone"
                    type="text"
                    aria-required="false"
                    aria-disabled="false"
                    autocomplete="off"
                    placeholder={dataProvider.placeholder}
                />
                <label
                    class="bno-form-control__label u-sr-only"
                    for="input-search"
                >
                    Hledat
                </label>
            </div>
            <button
                class="bno-toggle bno-toggle--plain"
                type="submit"
                aria-label="Odeslat formulář vyhledávání"
            >
                <span class="bno-icon bno-icon--search" />
            </button>
        </div>
    </div>
    <div class="bno-form-control">
        {#if processingActionTypes}
            <!-- <span>Načítání typů akce...</span> -->
        {:else if errorActionTypes}
            <span>Nastala chyba při načítání typů akce.</span>
        {:else if actionTypes.length}
            <div class="bno-select">
                <select
                    name="type"
                    id="select-type"
                    aria-required="false"
                    aria-disabled="false"
                    bind:value={dataProvider.actionType}
                    on:change={onSubmit}
                >
                    <option value="">Všechny typy akcí</option>

                    {#each actionTypes as option}
                        <option value={String(option.id)}>{option.nazev}</option
                        >
                    {/each}
                </select>
                <label
                    class="bno-form-control__label u-sr-only"
                    for="select-type"
                >
                    Všechny typy akcí
                </label>
            </div>
        {/if}
    </div>
</form>
